import { endpoints } from '../api/endpoints';
import { queryKeys } from './queryKeys';
import { queryConfig } from './queryConfig';
import { createListQueryHook } from './queryFactory';

export const useHeader = createListQueryHook({
  queryKey: queryKeys.header(),
  endpoint: endpoints.header,
  config: {
    staleTime: queryConfig.staleTime.long,
  },
});

